import axios from "../../utils/axios";
import { isImage } from "../../utils/image";

async function uploadFile({ file, img_sizes, model, id, img_field }) {
  const formData = new FormData();
  formData.append("file", file);
  if (img_sizes?.length && isImage(file)) {
    formData.append("img_sizes", img_sizes.join(","));
    formData.append("model", model);
    formData.append("id", id);
    formData.append("img_field", img_field);
  }

  const res = await axios.post("files", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return res.data;
}

async function deleteFile(fileUrl) {
  return await axios.delete("files", {
    data: { url: fileUrl },
  });
}

const fileServices = {
  uploadFile,
  deleteFile,
};

export default fileServices;
